import { Controls } from 'features/controls/Controls';
import { CountriesList } from 'features/countries/CountriesList';

export const HomePage = () => {
  return (
    <>
      <Controls />
      <CountriesList />
    </>
  );
};
